/* eslint-disable */
import React from 'react';
import * as MUI from '@material-ui/core';
import cn from 'classnames';
import FullscreenIcon from '../../../../icons/Fullscreen';
import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
    },
    drawer: {
      minHeight: '100vh',
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
    },
    toolbar: {
      justifyContent: 'flex-end',
      paddingRight: theme.spacing(4)
    },
    noPadding: {
      padding: '0',
    }
  })
);

export const Fullscreen: React.FC<{ onMount?: () => {}; noPadding?: boolean; refContent: React.MutableRefObject<HTMLElement | null> }> = (props) => {
  const classes = useStyles(props);
  const classNameButton = cn(classes.button);


  const [state, setState] = React.useState({
    open: false,
  });

  React.useEffect(() => {
    document.addEventListener('fullscreenchange', (event) => {
      let nextState: boolean = false;
      const documentAs = document as any;
      const fsE = documentAs['mozFullScreenElement'] || documentAs['webkitFullscreenElement'] || documentAs['msFullscreenElement'] || documentAs.fullscreenElement;
      if (fsE) {
        nextState = true;
      } else {
        nextState = false;
      }

      setImmediate(() => setState({ ...state, open: nextState }));
    });
  }, []);
  const handlerFSChange = React.useCallback((event, ...args) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    const documentAs = document as any;

    if (documentAs['msExitFullscreen']) {
      setState({open: !state.open}); // При IE всегда юудет сюда приходить, т.к. мы выключили полный экран
      return;
    }

    //Toggle fullscreen off, activate it
    if (!documentAs.fullscreenElement && !documentAs['mozFullScreenElement'] && !documentAs['webkitFullscreenElement'] && !documentAs['msFullscreenElement']) {
      if (documentAs.documentElement.requestFullscreen) {
        documentAs.documentElement.requestFullscreen().catch(() => setState({open: !state.open}));
      } else if (documentAs.documentElement['mozRequestFullScreen']) {
        documentAs.documentElement['mozRequestFullScreen']().catch(() => setState({open: !state.open})); // Firefox
      } else if (documentAs.documentElement['webkitRequestFullscreen']) {
        documentAs.documentElement['webkitRequestFullscreen']().catch(() => setState({open: !state.open})); // Chrome and Safari
      } else if (documentAs.documentElement['msRequestFullscreen']) {
        // document.documentElement['msRequestFullscreen']().catch(() => setState({open: !state.open})); // IE
      }

      //Toggle fullscreen on, exit fullscreen
    } else {

      if (documentAs.exitFullscreen) {
        documentAs.exitFullscreen().catch(() => setState({open: !state.open}));
      } else if (documentAs['msExitFullscreen']) {
        // document['msExitFullscreen']().catch(() => setState({open: !state.open}));
      } else if (documentAs['mozCancelFullScreen']) {
        documentAs['mozCancelFullScreen']().catch(() => setState({open: !state.open}));
      } else if (documentAs['webkitExitFullscreen']) {
        documentAs['webkitExitFullscreen']().catch(() => setState({open: !state.open}));
      }
    }


  }, [state]);

  return (<>
    <MUI.IconButton className={classNameButton} aria-label="Full screen" onClick={handlerFSChange}>
      <FullscreenIcon />
    </MUI.IconButton>
    <Drawer open={state.open} noPadding={props.noPadding} refContent={props.refContent} onMount={props.onMount} onClose={handlerFSChange} />
  </>);
}

function Drawer(props: { open: boolean, refContent: React.MutableRefObject<HTMLElement | null>, onClose: Function, onMount?: Function, noPadding?: boolean }) {
  const classes = useStyles(props);
  const { open, refContent, onClose, onMount } = props;
  const ref = React.createRef<HTMLDivElement>();
  React.useEffect(() => {
    setTimeout(() => {
      const current = ref.current;
      if (current) {
        const node = refContent.current;
        if (node) {
          if (open) {
            while (node.childNodes.length) {
              const childeNode = node.childNodes[0];
              current.appendChild(childeNode);
              onMount && onMount();
            }
          } else {
            while (current.childNodes.length) {
              const childeNode = current.childNodes[0];
              node.appendChild(childeNode);
            }
          }
        }
      }
    }, 40);
  }, [open]);

  return (
    <MUI.Drawer anchor="bottom" open={open} onClose={onClose as any} >
      <MUI.Paper className={cn(classes.drawer, props.noPadding && classes.noPadding)}>
        <MUI.Toolbar className={classes.toolbar}>
          <MUI.IconButton className={classes.button} aria-label="Full screen" onClick={onClose as any}>
            <FullscreenIcon />
          </MUI.IconButton>
        </MUI.Toolbar>

        <div ref={ref} style={{ display: 'flex', flex: 1 }}></div>
      </MUI.Paper>
    </MUI.Drawer>
  );
}